<div class="modal-header">
    <h4 class="modal-title">{{'AppointmentCompletion' | translateOrgSpecific}} </h4>
</div>
<div class="modal-body">

    <form #completeForm="ngForm">
        <div style="margin:50px;">
            <div class="row" style="margin-top:10px;">
                <div class="col-md-5 label-font-size">
                    <span>{{'Client' | translateOrgSpecific}}:</span>
                </div>
                <div class="col-md-7">
                    <span>{{appt.patientName}}</span>
                </div>
            </div>
            <div class="row" style="margin-top:10px;">
                <div class="col-md-5 label-font-size">
                    <span>{{'AppointmentTime' | translateOrgSpecific}}:</span>
                </div>
                <div class="col-md-7" *ngIf="appt.apptTime">
                    <span>
                        {{appt.apptTime | date : 'mediumDate'}}
                        &nbsp;
                        {{appt.apptTime | date : 'shortTime'}}
                    </span>
                </div>
            </div>
            <div class="row" style="margin-top:10px;">
                <div class="col-md-5 label-font-size">
                    <span>{{'Appointment' | translateOrgSpecific}} {{'StartTime' | translateOrgSpecific}}:</span>
                </div>
                <div class="col-md-7" *ngIf="appt.apptTime">
                    <span>
                        {{sessionDetails.startTime | date : 'mediumTime'}}
                    </span>
                </div>
            </div>
            <div class="row" style="margin-top:10px;">
                <div class="col-md-5 label-font-size">
                    <span>{{'Appointment' | translateOrgSpecific}} {{'EndTime' | translateOrgSpecific}}:</span>
                </div>
                <div class="col-md-7" *ngIf="appt.apptTime">
                    <span>
                        {{sessionDetails.endTime | date: 'mediumTime'}}
                    </span>
                </div>
            </div>
            <div class="row" style="margin-top:10px;">
                <div class="col-md-5 label-font-size">
                    <span>{{'DurationOfCall' | translateOrgSpecific}}:</span>
                </div>
                <div class="col-md-7" *ngIf="appt.apptTime">
                    <span>
                        {{sessionDetails.duration}}
                    </span>
                </div>
            </div>
            <div class="row" style="margin-top:10px;">
                <div class="col-md-5 label-font-size">
                    <span>{{'NextAppoinmentOn' | translateOrgSpecific}}:</span>
                </div>
                <div class="col-md-7" *ngIf="sessionDetails.nextApptAvailabel">
                    <span>
                        {{sessionDetails.nextApptDate | date:'d MMM yyyy'}} {{sessionDetails.nextApptStartTime}}
                        {{'To' | translateOrgSpecific}}
                        {{sessionDetails.nextApptEndTime}}
                    </span>
                </div>
                <div class="col-md-7" *ngIf="!sessionDetails.nextApptAvailabel">
                    <label>{{'NoOtherAppoinments' | translateOrgSpecific}} </label>
                </div>
            </div>

            <div class="row" style="margin-top:10px;">
                <div class="col-md-5 form-group required ">
                    <span class="control-label label-page label-font-size">{{'Notes' | translateOrgSpecific}}: </span>
                </div>
                <div class="col-md-7" *ngIf="appt.apptTime">
                    <textarea #note="ngModel" id="note" name="note" [(ngModel)]="notes" class="form-control-theme"
                        style="resize: both;" rows="5" cols="32" required
                        [class.is-invalid]="note.invalid && note.touched"></textarea>
                </div>
            </div>
            <div class="row" style="margin-top:20px;">
                <div class="col-md-5 label-font-size">
                </div>
                <div class="col-md-7">
                    <button *ngIf="appt.apptTime" style="width:80px;display: inline-block;"
                        class="btn btn-apportis-primary-theme btn-block" (click)="complete()"
                        [disabled]="!completeForm.form.valid">{{'Complete' | translateOrgSpecific}}</button>
                </div>
            </div>

        </div>
    </form>
</div>